import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { blobURL } from "common/StringUtils";
import { useEffect } from "react";
import { LOCALES } from "common/constants";
import { getSchemaMarkup } from "common/FunctionUtils";

const SelfEmployment = ({ dashboardFooter }) => {
  const schemaMarkup = getSchemaMarkup("egenanstallning");
  const { t } = useTranslation();

  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);
  let language = localStorage.getItem("i18nextLng");
  const thisSelf = `${blobURL}/this_self_employee.png`;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="self-employment-page top-sub-menu-page">
      <Helmet>
        {schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
          </script>
        )}
        <title>
          {t("Invoicing without a company: Self-employment with Invozio")}
        </title>
        <meta
          name="description"
          content={t(
            "What is self-employment and what advantages does it have compared to starting your own business? We explain the meaning of self-employment and how it simplifies your freelance work."
          )}
        />
        {language === LOCALES.EN_US ? (
          <link rel="canonical" href="https://invozio.com/self-employment" />
        ) : (
          <link rel="canonical" href="https://invozio.com/egenanstallning" />
        )}
      </Helmet>
      <Header />

      <Container className="p-0 self_new nw_eployment abut_slf network-page">
        <div className="new_desgn_insurance p-0 self-employment-about top-menu-section mt-5 self_eloyeeee new_margin_header">
          <section className="insurns_wrap aboutself ins_respnvs info_wrap">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="security_fntw">
                    <h1 className="security_about text-uppercase mb-0">
                      {t("Self-employment")}
                    </h1>
                    <h2 className="fnt_family">
                      {t(
                        "Invoicing without your own company is a model that has emerged because many people find it complicated to run and start their own business."
                      )}
                    </h2>
                    {!user && (
                      <Button
                        variant=""
                        className="mt-3 new_theme_btn "
                        onClick={() =>
                          navigate(
                            language === LOCALES.EN_US
                              ? `/emailregister?lang=${LOCALES.EN_US}`
                              : `/e-postregister?lang=${LOCALES.SV_SE}`
                          )
                        }
                      >
                        {t("Create Free Account")}
                      </Button>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="flt_ryt">
                    <div className="image_wrap">
                      <img
                        src={thisSelf}
                        alt="self-employee"
                        className="image-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="newdesign">
            <div className="container p-0">
              <div className="without_background">
                <div className="new_text mt-2">
                  <h2 className="mb-2 accident_ins">
                    {t("What does self-employment mean?")}
                  </h2>
                  <p>
                    {t(
                      "Self-employment means that you are employed in a self-employment company during the time you perform an assignment with a customer. After completion of the assignment, or monthly, the customer is invoiced by the self-employment company, which also pays you a salary as a self-employed person. The self-employment company takes full employer responsibility and reports VAT, taxes and social security contributions to the tax authority."
                    )}
                  </p>
                </div>
                <h2>
                  {t(
                    "We make it easy for you to invoice without having a company as a self-employed individual"
                  )}
                </h2>

                <p className="insurance_para mb-2">
                  {t(
                    "In today's rapidly changing job market, it is evident that traditional forms of employment are no longer the only option for those who want to have control over their work situation while still feeling secure. Self-employment offers a flexible solution that can serve as a way into the job market, where you can get paid for temporary assignments, or as a first step for those who want to test their business idea before deciding to start their own company."
                  )}
                </p>

                <p className="insurance_para mb-2">
                  {t(
                    "With our service, you gain access to all the necessary tools to manage invoices, track payments, and handle taxes. All of this is gathered under one roof, allowing you to focus on what you do best – performing your work and building relationships with your clients. We take care of all the administration, so you don't have to worry about the tedious details. Our platform is specifically designed for freelancers, consultants, and people who take on temporary assignments. It makes it easier than ever to keep your business organized and ensure everything runs smoothly."
                  )}
                </p>
                {/* <div className="new_text">
                  <h6 className="mb-2 accident_ins">
                    {t("Get answers to your questions about self-employment")}
                  </h6>
                  <p>{t("Questions and answers")}</p>
                </div> */}
              </div>
              <div className="with_background">
                <h2>{t("Advantages of self-employment")}</h2>
                {/* <h6 className="mb-2 accident_ins">
                  {t("Accident insurance")}
                </h6> */}
                <p className="insurance_para mb-2">
                  {t(
                    "The benefits of self-employment are numerous. No contractor is too small or too large for Invozio. Whether you're a beginner or an experienced professional, you can work with both regular and temporary assignments. You are specifically employed for the duration of the assignment, giving you the security of knowing that you have a formal employment during that period."
                  )}
                </p>

                <div className="new_text mt-2">
                  <h2 className="mb-2 accident_ins">
                    {t("Start Invoicing in Just a Few Minutes")}
                  </h2>
                  <p className="insurance_para">
                    {t(
                      "Invoicing with us is quick and easy. You don’t need any prior knowledge to get started. In just a few minutes, you can create an account and send your first invoice. Our platform is designed to be user-friendly and intuitive, allowing you to focus on what really matters – your work. With no initial invoicing fee, it’s even more appealing. Joining Invozio costs only 1.9%, making self-employment an excellent way to test and launch a business without large investments."
                    )}
                  </p>
                </div>

                <div className="new_text">
                  <h2 className="mb-2 accident_ins">
                    {t("Insurance as a Self-Employed Worker")}
                  </h2>
                  <p className="insurance_para">
                    {t(
                      "Another great advantage of being self-employed with us is that you are always insured. As a self-employed contractor, you are covered by accident and life insurance during the jobs you take. Additionally, you are protected by liability insurance, giving you extra security when working with different assignments and clients."
                    )}
                  </p>
                </div>

                <div className="new_text">
                  <h2 className="mb-2 accident_ins">
                    {t("Minimizing Administration")}
                  </h2>
                  <p className="insurance_para">
                    {t(
                      "One of the most appreciated aspects of our service is the lack of administration for your self-employment. As a self-employed contractor, you can fully focus on your assignments and creative work. Invoice management, debt collection, and reporting to the Swedish Tax Agency are handled by our self-employment company, meaning you can avoid the administrative burden and spend more time developing your business and building relationships with your clients."
                    )}
                  </p>
                  <p className="insurance_para mb-2">
                    {t(
                      "In summary, we offer a smooth and efficient solution for the self-employed who want freedom and flexibility in their work, without worrying about the administrative side of running a business. Welcome to Invozio – your partner in self-employment!"
                    )}
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Container>
      <Footer dashboardFooter={dashboardFooter} />
    </div>
  );
};

export default SelfEmployment;
